export const environment = {
  production: false,
  app_version: "ver0.0.1 - 7/1/2024 19:41",
  storage_version: "ver1.0.2",
  sprite_url: "assets/svg/icons.svg?version=2024-07-1819:40:33",
  base_url: "https://api.culture-embed.com",
  graphql_url: "https://api.culture-embed.com/graphql"
};
